module.exports = __webpack_public_path__ + "static/img/icon15.664bb42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon15.png
// module id = pM56
// module chunks = 0